// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highlight-token {\n  border: 1px solid transparent;\n  border-radius: 2px;\n  outline: none;\n  margin: auto -2px auto 2px;\n  padding: 0 1px;\n  display: inline;\n  background-color: #E0FFFF;\n}\n.highlight-token.correct {\n  background-color: #ffff99;\n}\n", ""]);
// Exports
module.exports = exports;
